import { client } from "./client";
import interceptors from "./interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function dataVoucher(params) {
    return client.get("/tunnel/api/pos/voucher/get_voucher", {
        params: params,
    });
}

function checkVoucher(params) {
    return client.get("/tunnel/api/pos/voucher/check_voucher", {
        params: params,
    });
}

function claimVoucher(params) {
    return client.post("tunnel/api/pos/voucher/claim_voucher", qs.stringify(params), {
        header: {
            "Content-Type": "application/x-www-form-urlencoded"
        }
    });
}

export default {
    dataVoucher,
    checkVoucher,
    claimVoucher
};